<template>
  <LinkAndText
    :background-class="configData.BackgroundClass"
    :title="configData.Title"
    :text="configData.Text"
    :link-button-text="configData.LinkButtonText"
    :link-button-url="configData.LinkButtonUrl"
  ></LinkAndText>
</template>

<script lang="ts" setup>
interface Props {
  configData: {
    BackgroundClass: string;
    Title: string;
    Text: string;
    LinkButtonText: string;
    LinkButtonUrl: string;
  };
}

defineProps<Props>();
</script>

<style scoped></style>
